"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coeTheme = exports.coeOverrides = exports.COE_SELECTED_BUTTON = exports.COE_BACKGROUND = exports.COE_BUTTON = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var typography_1 = require("./typography");
var commonStyles_1 = require("./commons/commonStyles");
var theme_1 = require("./theme");
var commons_1 = require("./commons");
exports.COE_BUTTON = '#1b7eac';
exports.COE_BACKGROUND = '#123751';
exports.COE_SELECTED_BUTTON = '#136f8e';
exports.coeOverrides = tslib_1.__assign({ MuiDrawer: {
        paperAnchorLeft: {
            backgroundColor: exports.COE_BACKGROUND,
        },
    }, MuiListItem: {
        root: {
            '&[data-signa="sidebar-item"]': {
                '&$selected': {
                    backgroundColor: exports.COE_SELECTED_BUTTON,
                },
            },
        },
    }, MuiButton: {
        containedPrimary: {
            '&[data-signa="sidebar-button"]': {
                backgroundColor: exports.COE_BUTTON,
            },
        },
    }, MuiIconButton: {
        colorPrimary: {
            '&[data-signa="fake-button"]': {
                backgroundColor: exports.COE_BUTTON,
            },
        },
    }, MuiCircularProgress: {
        colorPrimary: {
            color: commons_1.mediumGreen,
        },
    }, MuiSnackbar: {
        root: {
            borderRadius: '8px',
        },
        anchorOriginTopCenter: {
            top: '16px',
            left: '16px',
            right: '16px',
        },
    }, MuiSnackbarContent: commonStyles_1.MuiSnackbarContent }, theme_1.typographyColors);
var coeTheme = function () {
    var theme = (0, core_1.createMuiTheme)({
        palette: theme_1.appPalette,
        typography: typography_1.typography,
        overrides: exports.coeOverrides,
    });
    return theme;
};
exports.coeTheme = coeTheme;
